import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import '@sdir/sds/lib/components/index.css';
import './index.css';
import AppProviders from './components/AppProviders';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <Suspense fallback={<div>Loading ...</div>}>
    <AppProviders />
  </Suspense>
);
